import { toDate } from 'date-fns';
import type { TestFunction } from 'yup';

import { dateStringToTimestamp } from 'shared/lib/dates';

import { validatePassportDate } from './validatePassportDate';

export const isPassportDateCorrect: TestFunction = (value, context) => {
  let isValid = false;
  if (value) {
    const birthDate = toDate(dateStringToTimestamp(String(context.parent.birthDate)));
    const passportIssueDate = toDate(dateStringToTimestamp(String(value)));

    isValid = validatePassportDate(birthDate, passportIssueDate);
  }
  return isValid || context.createError({ path: context.path, message: 'Паспорт недействителен' });
};
